import React from 'react';
import Body from 'Feature/Arrears/components/ArrearsInquiryPage/ui/common/Body';
import formatAmountWithDollar from 'Feature/V2/HbtPortfolioManagement/utils/FormatAmountWithDollar';

interface AmountFieldProps {
  amount: number;
  language: string;
}

export const AmountField = ({ amount, language }: AmountFieldProps) => {
  return <Body size={'small'}>{formatAmountWithDollar(amount, language)}</Body>;
};
